import { getPayPrice } from '@/api/price'

// const arr = [
//   { title: '超级会员（全部功能）',
//     name: 'LDMALL',
//     values: [
//       { id: 1, period: '1个月', amount: 3500, oldAmount: 4500, max: 3000, coupon: '', reward: 0 },
//       { id: 2, period: '12个月', amount: 17500, oldAmount: 27500, max: 17000, coupon: '', reward: 7000 },
//       { id: 3, period: '24个月', amount: 27500, oldAmount: 45500, max: 27000, coupon: '', reward: 9000 },
//       { id: 4, period: '长期有效', amount: 67500, oldAmount: 95500, max: 60000, coupon: '', reward: 18000 }
//     ]
//   },
//   { title: 'BooleanDA文档小助手',
//     name: 'EXE001',
//     values: [
//       { id: 1, period: '1个月', amount: 2500, oldAmount: 5500, max: 2000, coupon: '', reward: 0 },
//       { id: 2, period: '12个月', amount: 12500, oldAmount: 22500, max: 12000, coupon: '', reward: 4000 },
//       { id: 3, period: '24个月', amount: 22500, oldAmount: 35500, max: 20000, coupon: '', reward: 6000 },
//       { id: 4, period: '长期有效', amount: 57500, oldAmount: 75500, max: 50000, coupon: '', reward: 18000 }
//     ]
//   },
//   { title: 'Word小助手',
//     name: 'VST002',
//     values: [
//       { id: 1, period: '1个月', amount: 1000, oldAmount: 5500, max: 500, coupon: '', reward: 0 },
//       { id: 2, period: '12个月', amount: 6500, oldAmount: 22500, max: 6000, coupon: '', reward: 1500 },
//       { id: 3, period: '24个月', amount: 10500, oldAmount: 35500, max: 10000, coupon: '', reward: 3000 },
//       { id: 4, period: '长期有效', amount: 35500, oldAmount: 61500, max: 30000, coupon: '', reward: 10000 }
//     ]
//   },
//   { title: 'Excel小助手',
//     name: 'VST001',
//     values: [
//       { id: 1, period: '1个月', amount: 1000, oldAmount: 5500, max: 500, coupon: '', reward: 0 },
//       { id: 2, period: '12个月', amount: 6500, oldAmount: 22500, max: 6000, coupon: '', reward: 1500 },
//       { id: 3, period: '24个月', amount: 10500, oldAmount: 35500, max: 10000, coupon: '', reward: 3000 },
//       { id: 4, period: '长期有效', amount: 35500, oldAmount: 61500, max: 30000, coupon: '', reward: 10000 }
//     ]
//   },
//   { title: 'PDF小助手',
//     name: 'PDF001',
//     values: [
//       { id: 1, period: '1个月', amount: 1000, oldAmount: 5500, max: 500, coupon: '', reward: 0 },
//       { id: 2, period: '12个月', amount: 6500, oldAmount: 22500, max: 6000, coupon: '', reward: 1500 },
//       { id: 3, period: '24个月', amount: 10500, oldAmount: 35500, max: 10000, coupon: '', reward: 3000 },
//       { id: 4, period: '长期有效', amount: 35500, oldAmount: 61500, max: 30000, coupon: '', reward: 10000 }
//     ]
//   }
// ]
const arr = []
export var tabList = arr

export async function getPrice() {
  var params = {
    'name': 'all'
  }
  return await getPayPrice(params).then((res) => {
    // console.log('查询会员类型数据')
    // console.log(res)
    if (res['code'] === 200) {
      // console.log('data数据：')
      // console.log(res['data'])
      return res['data']
    }
  })
}
